export default "__VITE_ASSET__j3C_di0c__"